/**
 * @file versions.tab.tsx
 * @description Вкладка версий для формы тестового случая.
 * Отображает таблицу версий тест-кейса с информацией о поддерживаемых релизах.
 * Позволяет добавлять новые версии, редактировать существующие и удалять их.
 * Автоматически загружает данные с сервера при открытии вкладки.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @src/types, @components/form-controls/table, @utils/table-view, @api/actions, @components/icons/trash-flat, @utils/form-object-helper]
 * @related-files [@components/form-controls/table/table.component.tsx, @utils/table-view.tsx, @api/actions/object-form.service.tsx, @utils/form-object-helper.ts]
 */

import { GuidUtils, tabProps } from '@src/types';
import { Table } from '@components/form-controls/table';
import { getDefaultCell } from '@utils/table-view';
import { ObjectFormService } from '@api/actions';
import { useEffect } from 'react';
import { TrashFlatIcon } from '@components/icons/trash-flat';
import { getSimpleObject } from '@utils/form-object-helper';

export const Versions = ({ control, data, tab, getValues, setValue }: tabProps) => {
    useEffect(() => {
        if (getValues && !getValues(tab || 'versions')) {
            getPageData();
        }
    }, []);

    const getPageData = async () => {
        if (!data?.item) {
            return;
        }

        const response = await ObjectFormService.get(data.item.$type, data.item.id, tab);

        if (response && setValue) {
            setValue(tab || 'versions', response);
        }
    };

    return (
        <Table
            columns={columns}
            addItemType="new"
            type="TestCaseVersion"
            name={tab || 'versions'}
            control={control}
            isCanAddRows={true}
            isRowClickable={true}
            initialItem={{ name: '', $type: 'TestCaseVersion', id: GuidUtils.empty(), owner: getSimpleObject(data?.item) }}
            contextMenuItemList={contextMenuItemList}
        />
    );
};

//TODO: пересмотреть подход к указанию элементов контекстного меню, возможно через отдельно свойство
const contextMenuItemList = [
    {
        label: 'Удалить',
        icon: <TrashFlatIcon className="text-[#B2C8D4] hover:text-[#99B8C9]" />,
        clickHandler: (row: any, rows: any[], onChange: any) => {
            onChange(rows.filter((item) => item.id !== row.id));
        },
        isOnlyIcon: true
    }
];

const columns = [
    {
        id: '$item',
        header: [{ text: 'Код' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'releaseSupportStart',
        header: [{ text: 'релиз начала поддержки' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'releaseSupportEnd',
        header: [{ text: 'релиз окончания поддержки' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    }
];
